(function () {
    angular
        .module('servicesModule')
        .controller('dialogExporter', ['$window', '$scope', '$http', '$stateParams', 'ngDialog', 'commonService', dialogExporter]);

    function dialogExporter($window, $scope, $http, $stateParams, ngDialog, commonService) {
        $scope.resources = globalResources;
        $scope.isExportExcel = true;
        $scope.fileName = $scope.ngDialogData.fileName;

        $scope.submit = submit;
        $scope.cancel = cancel;
        $scope.toggleExcelExport = toggleExcelExport;
        $scope.toggleWordExport = toggleWordExport;

        //init current language
        $scope.language = commonService.getCurrentLanguageText();

        function toggleExcelExport() {
            $scope.isExportWord = false;
        }

        function toggleWordExport() {
            $scope.isExportExcel = false;
        }

        function submit() {
            var extension = $scope.isExportExcel ? "xlsx" : "docx";

            var url = '';
            var exportParams = $scope.ngDialogData.exportParams;

            if ($scope.ngDialogData.exporterUrl && $scope.ngDialogData.exporterUrl.length) {
                url = $scope.ngDialogData.exporterUrl;
                exportParams.exportType = $scope.isExportExcel ? E.ExportTypes.Excel : E.ExportTypes.Word;
            } else {
                url = $scope.isExportExcel ? $scope.ngDialogData.excelExporterUrl : $scope.ngDialogData.wordExporterUrl;
            }

            $scope.ngDialogData.exportParams.language = $scope.language;
            $http({
                url: url,
                method: 'POST',
                data: $scope.ngDialogData.exportParams,
                responseType: 'blob'
            })
            .success(function (data) {
                ngDialog.close();
                var fileName = $scope.fileName + "." + extension;
                $window.saveAs(data, fileName);
            });
        }

        function cancel() {
            ngDialog.close();
        }
    }
})();